const render = ({ title, instructions, password_width, alignment, form_centered}) => {

  const elInstruction = instructions ? `<span class="accountPassword__instructions">${instructions}</span>` : ''
  const elTitle = title ? `<span class="accountPassword__title">${title}</span>` : ''

  return `
<div class="accountPassword">
  <form class="accountPassword__form">
    
    ${elTitle}
    ${elInstruction}

    <div class="accountPassword__row">
      <div class="accountPassword__formGroup">
        <label class="accountPassword__label">
          Password
        </label>
        <input type="password" id="path-pw-input" class="accountPassword__control" name="password"/>
        <div id="path-pw-passwordmessage" class="accountPassword__errorMessage"></div> 
      </div>
      <div class="accountPassword__formGroup">
        <label class="accountPassword__label">
          Password Confirmation
        </label>
        <input type="password" id="path-pw-confirm-input" class="accountPassword__control" name="password_confirmation"/>
      </div>
    </div>
  </form>

  <style>

    .accountPassword {
      margin-bottom: 24px;
    }

    .accountPassword__form {
    }
    
    .accountPassword__title {
      display: block;
      font-size: 24px;
      text-align: ${form_centered ? 'center' : 'left'};
    }
    
    .accountPassword__instructions {
      display: block;
      font-size: 18px;
      text-align: ${form_centered ? 'center' : 'left'};
    }
    
    .accountPassword__row {
      display: flex;
      margin: ${form_centered ? 'auto' : '0'};
      flex-direction: ${alignment ? 'column' : 'row'};
      margin-top: 24px;
      width: ${password_width};
    }

    .accountPassword__formGroup {
      margin-bottom: 12px;
      flex: 1;
    }

    .accountPassword__formGroup:first-child {
      margin-right: ${alignment ? '0' : '15px'};
    }
    
    .accountPassword__label {
      font-weight: bold;
      display: block;
      margin-bottom: 4px;
    }

    .accountPassword__control {
      background-color: #FFFFFF;
      border: 1px solid #CCCCCC;
      border-radius: 4px;
      padding: 12px 18px;
      width: 100%;
    }

    .accountPassword__errorMessage {
      color: #F03030
    }
  </style>

</div>
  `.trim()
};

export default render;